const initParallax = () => {
  window.addEventListener('mousemove', function (e) {
    let target_1 = document?.querySelectorAll('.home__img-img'),
      target_2 = document?.querySelectorAll('.pay-parallax'),
      target_3 = document?.querySelectorAll('.about__img-1'),
      target_4 = document?.querySelectorAll('.about__img-2'),
      target_5 = document?.querySelectorAll('.about__img-3'),
      target_6 = document?.querySelectorAll('.about__img-4'),
      target_7 = document?.querySelectorAll('.about__img-5'),
      target_8 = document?.querySelectorAll('.useful-img');

    let x = e.clientX / window.innerWidth;
    let y = e.clientY / window.innerHeight;
    target_1[0].style.transform =
      'translate(-' + x * 30 + 'px, -' + y * 40 + 'px)';
    target_1[1].style.transform =
      'translate(+' + x * 80 + 'px, +' + y * 70 + 'px)';
    target_1[2].style.transform =
      'translate(-' + x * 100 + 'px, -' + y * 80 + 'px)';

    if (target_8.length > 0) {
      [...target_8][1].style.transform =
        'translate(+' + x * 30 + 'px, +' + y * 40 + 'px)';
      [...target_8][2].style.transform =
        'translate(-' + x * 40 + 'px, -' + y * 50 + 'px)';
      [...target_8][3].style.transform =
        'translate(-' + x * 30 + 'px, -' + y * 30 + 'px)';
    }

    if (target_2.length > 0) {
      target_2[0].style.transform =
        'translate(-' + x * 10 + 'px, -' + y * 30 + 'px)';
      target_2[1].style.transform =
        'translate(+' + x * 30 + 'px, +' + y * 40 + 'px)';
    }

    [...target_3].map((it) => {
      it.style.transform = 'translate(+' + x * 30 + 'px, +' + y * 40 + 'px)';
    });
    [...target_4].map((it) => {
      it.style.transform = 'translate(-' + x * 40 + 'px, -' + y * 50 + 'px)';
    });
    [...target_5].map((it) => {
      it.style.transform = 'translate(+' + x * 20 + 'px, +' + y * 40 + 'px)';
    });
    [...target_6].map((it) => {
      it.style.transform = 'translate(-' + x * 30 + 'px, -' + y * 30 + 'px)';
    });
    [...target_7].map((it) => {
      it.style.transform = 'translate(-' + x * 20 + 'px, -' + y * 10 + 'px)';
    });
  });
};

export default initParallax;
